export default function ParallaxSroll() {
  const parallaxItems = document.querySelectorAll<HTMLDivElement>(".js-parallax-item");

  if (parallaxItems && parallaxItems.length > 0) {
    parallaxItems.forEach((item) => {
      const handleScrollPosition = (scrollY: number) => {
        item.style.transform = `translateY(${-scrollY * 0.25}px)`;
      };
      // on scroll
      window.addEventListener("scroll", () => {
        handleScrollPosition(window.scrollY);
      });
      // on init
      handleScrollPosition(window.scrollY);
    });
  }
}
